// Create a utility function for password recovery API call like in auth. the api is in post method. i will give the username from frontend. first api will be for getting masked mobile numbers
import { POST } from './Request'
import { GET_RECOVERY_MOBILES, SEND_NEW_PASSWORD } from '../const/api'

async function getRecoveryMobiles(username) {

//  console.log('Fetching recovery mobiles for username:', username);
  try {
    const response = await POST(GET_RECOVERY_MOBILES, { username })
    return response.data
  } catch (error) {
    // console.log(error.response.data)
    return error.response.data
  }
}
// send new password function goes here
async function sendNewPassword(username, mobile_type) {
  try {
    const response = await POST(SEND_NEW_PASSWORD, { username, mobile_type })
    return response.data
  } catch (error) {
    console.log(error)
    return null
  }
}

export { getRecoveryMobiles, sendNewPassword }